<template>
  <div class="p-6">
    <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
      Import Sitemap
    </h2>
    <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
      Import pages from a sitemap XML file for <strong>{{ websiteName }}</strong>
    </p>

    <form @submit.prevent="handleSubmit" class="space-y-6">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Sitemap URL *</label>
        <UiFormInput v-model="sitemapUrl" type="text" placeholder="https://example.com/sitemap.xml" />
      </div>

      <div v-if="result" class="rounded-md bg-green-50 dark:bg-green-900/20 p-4">
        <p class="text-sm text-green-700 dark:text-green-400">
          Successfully imported {{ result.pages_created }} page{{ result.pages_created === 1 ? '' : 's' }}.
        </p>
      </div>

      <div v-if="errors" class="rounded-md bg-red-50 dark:bg-red-900/20 p-4">
        <p class="text-sm text-red-700 dark:text-red-400">
          {{ errors }}
        </p>
      </div>

      <div class="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          @click="$emit('on-close-panel')"
          class="px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
          {{ result ? 'Close' : 'Cancel' }}
        </button>
        <button
          v-if="!result"
          type="submit"
          :disabled="importing || !sitemapUrl"
          class="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 disabled:opacity-50">
          {{ importing ? 'Importing...' : 'Import' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { importSitemap } from '~/javascript/api/websites.js'
import { UiFormInput } from '~/javascript/components/ui/form/input'

const props = defineProps({
  websiteId: { type: String, required: true },
  websiteName: { type: String, default: '' }
})

const emit = defineEmits(['on-close-panel', 'imported'])

const sitemapUrl = ref('')
const importing = ref(false)
const errors = ref(null)
const result = ref(null)

const handleSubmit = async() => {
  try {
    importing.value = true
    errors.value = null
    result.value = null

    const response = await importSitemap(props.websiteId, sitemapUrl.value)
    result.value = response.data
    emit('imported')
  } catch (error) {
    errors.value = error.response?.data?.message || 'Import failed. Please check the URL and try again.'
  } finally {
    importing.value = false
  }
}
</script>
